module.exports = __webpack_public_path__ + "img/18_54.ff49ecae.png";